<template>
  <v-form :disabled="$loader.loading">
    <v-row>
      <v-col cols="4">
        <v-text-field
          v-model="model.name"
          variant="outlined"
          label="Nome"
          required
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="model.email"
          variant="outlined"
          label="E-mail"
          required
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="model.tag"
          variant="outlined"
          label="Tag"
          required
        />
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="model.observation"
          variant="outlined"
          label="Observações"
          required
        />
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="2">
        <v-btn
          color="primary"
          block
          :loading="$loader.loading"
          @click="submit"
        >
          Criar
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import type Affiliate from '@/types/Affiliate'

export default defineComponent({
  props: {
    affiliate: {
      type: Object as PropType<Affiliate>,
      required: true,
    },
  },
  emits: [ 'submit' ],
  data() {
    return {
      model: this.affiliate,
    }
  },
  watch: {
    affiliate(_new) {
      this.model = _new
    },
  },
  methods: {
    submit() {
      this.$emit('submit', this.model)
    },
  },
})
</script>
